'use strict';

var ChartFaresLegendController = function ChartFaresLegendController($scope, chartFaresService) {
  $scope.legendItems = [];
  $scope.title = chartFaresService.getLegendTitle(chartFaresService.getCurrentYear());
  $scope.legendIsCollapsed = true;
  $scope.isNoRaDataMarketSelected = false;
  $scope.fillRows = function () {
    $scope.legendItems = chartFaresService.sortLegend($scope.legend);
  };
  $scope.legendClickHandler = function (element) {
    var selectedLegend = chartFaresService.getSelectedLegend($scope.legend);
    if (selectedLegend.length <= 1 && element.selected) {
      return;
    }
    element.selected = !element.selected;
  };
  $scope.fillLegendTitle = function () {
    $scope.title = chartFaresService.getLegendTitle(chartFaresService.getCurrentYear());
  };
  $scope.isNoRaDataMarket = function () {
    return $scope.isNoRaDataMarketSelected;
  };
  $scope.fillRows();
};
ChartFaresLegendController.$inject = ['$scope', 'ChartFaresService'];
module.exports = ChartFaresLegendController;